<script>
  import {
    CornerUpRightIcon,
    MoreVerticalIcon,
  } from 'vue-feather-icons'

  export default {
    components: {
      CornerUpRightIcon,
      MoreVerticalIcon,
    },
  }
</script>

<template>
  <article class="tw-flex tw-justify-between tw-pl-0.5">
    <section class="!tw-inline-flex tw-pb-2">
      <CornerUpRightIcon size="2.185x" class="mg-b-n-6 mg-l-n-1 mg-r-10 mt-1" />
      <FabricDropdown
        text="Dropdown Button"
        variant="light-blue"
        class="dropdown-circle positive dropdown-borded dropdown-circle-sm border-thin tw-text-primaryLightened">
        <template v-slot:button-content>
          <MoreVerticalIcon size="1x" class="tw-text-primaryLightened" />
        </template>
        <slot name="drop-down-elements"></slot>
      </FabricDropdown>
    </section>
  </article>
</template>
